import User from "../entities/getUser";
import UserInfo from "../entities/user";
import { OnboardingRepository } from "../repositories/OnboardingRepository";

export class UpdateUser {
	constructor(private repository: OnboardingRepository) {}
	execute(params: UpdateUserParams): Promise<User> {
		return this.repository.updateUser(params.data);
	}
}

export class UpdateUserParams {
	constructor(public data: UserInfo) {}
}
